export default __webpack_public_path__ + "static/media/Location_Mecklenburg-Vorpommern.3c67a90c.svg";